import { useCallback } from 'react';

export const useGoto = () => {
  const goToTop = useCallback(
    () => {
      window.scroll({ top: 0, behavior: 'smooth' });
    },
    [],
  );

  return goToTop;
};

export default useGoto;
